import React, { useEffect } from "react";
import { jsPDF } from "jspdf";
import autoTable from "jspdf-autotable";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import robotoFont from "../../fonts/Roboto-Regular-base64";

const ExportButtons = ({ data }) => {
  useEffect(() => {
    jsPDF.API.events.push([
      "addFonts",
      function () {
        this.addFileToVFS("Roboto-Regular.ttf", robotoFont);
        this.addFont("Roboto-Regular.ttf", "Roboto", "normal");
      },
    ]);
  }, []);

  const exportPDF = () => {
    const doc = new jsPDF();

    doc.setFont("Roboto");
    doc.text("Lista Petiții", 14, 15);

    autoTable(doc, {
      head: [[
        "Prenume",
        "Nume",
        "Email",
        "Telefon",
        "Oraș",
        "Județ",
        "Țară",
        "Nume Petiție",
      ]],
      body: data.map((p) => [
        p.prenume || "",
        p.nume || "",
        p.email || "",
        p.numar_telefon || "",
        p.oras || "",
        p.judet || "",
        p.tara || "",
        p.nume_petitie || "",
      ]),
      startY: 20,
      styles: { font: "Roboto", fontSize: 8 },
      headStyles: { fillColor: [22, 160, 133] },
    });

    doc.save("petitii.pdf");
  };

  const exportExcel = () => {
    const exportData = data.map((p) => ({
      Prenume: p.prenume || "",
      Nume: p.nume || "",
      Email: p.email || "",
      Telefon: p.numar_telefon || "",
      Oraș: p.oras || "",
      Județ: p.judet || "",
      Țară: p.tara || "",
      "Nume Petiție": p.nume_petitie || "",
    }));

    const worksheet = XLSX.utils.json_to_sheet(exportData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Petiții");
    const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
    const dataBlob = new Blob([excelBuffer], { type: "application/octet-stream" });
    saveAs(dataBlob, "petitii.xlsx");
  };

  return (
    <div className="d-flex gap-3 mt-3 neumorphic p-3 rounded justify-content-center">
      <button className="btn btn-outline-primary" onClick={exportPDF}>
        Exportă PDF
      </button>
      <button className="btn btn-outline-success" onClick={exportExcel}>
        Exportă Excel
      </button>
    </div>
  );
};

export default ExportButtons;
